import {Injectable} from '@angular/core';
import {CommonResponse} from "../response/common.response";
import {ApiResumengraficoRepository} from "../services/api/resumengrafico/api.resumengrafico.repository";

@Injectable({
    providedIn: 'root'
})

export class ResumenGraficos {
    constructor(
        public apiResumengraficoRepository?: ApiResumengraficoRepository
    ) {
    }

    public async getTotalesDashboard(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getTotalesDashboard(objEnvio);
    }

    public async getGraficoTopCliente(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getGraficoTopCliente(objEnvio);
    }

    public async getGraficoOperacionesOperador(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getGraficoOperacionesOperador(objEnvio);
    }

    public async getClasificacionClientesByOperador(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getClasificacionClientesByOperador(objEnvio);
    }

    public async getDetalleClientesOtrosVisor(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getDetalleClientesOtrosVisor(objEnvio);
    }

    public async getEstadoCuentaActualOperador(): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getEstadoCuentaActualOperador();
    }

    public async getDamKpiTotales(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getDamKpiTotales(objEnvio);
    }

    public async getDamKpiGraficoPie(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getDamKpiGraficoPie(objEnvio);
    }

    public async getDamKpiGraficoBarCliente(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getDamKpiGraficoBarCliente(objEnvio);
    }

    public async getDamKpiDetalle(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getDamKpiDetalle(objEnvio);
    }

    public async getGraficoMovimientosPorTipoContenedor(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getGraficoMovimientosPorTipoContenedor(objEnvio);
    }

    public async getGraficoMovimientosPorTipoEmbarque(objEnvio: any): Promise<CommonResponse> {
        // @ts-ignore
        return await this.apiResumengraficoRepository.getGraficoMovimientosPorTipoEmbarque(objEnvio);
    }

}
